/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import * as _ from 'lodash';

import template from './team-list-page.component.html';
import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {OgTranslateService} from '../../common/filters/og-translate.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

interface TeamFeeRow {
  label: string;
  fee: any;
}

@Component({
  standalone: false,
  selector: 'adn-team-list-page',
  template
})
export class TeamListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adm.teams.team';

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    private readonly ogTranslate: OgTranslateService
  ) {
    super(LocalNetworkProfile);
  }

  get columns(): AdminListColumn[] {
    return this.normalizeColumns(this.list?.teamFields || []);
  }

  hasColumn(label: string): boolean {
    return (this.list?.selFields || []).indexOf(label) > -1;
  }

  getTargetTranslation(apiValue: string): string {
    if (this.list?.getTargetTranslation) {
      return this.list.getTargetTranslation(apiValue);
    }
    return apiValue;
  }

  getTeamFeeRows(team: any): TeamFeeRow[] {
    const rows: TeamFeeRow[] = [];
    if (team.techFeeCpm) {
      rows.push({label: this.ogTranslate.transform('techFee'), fee: team.techFeeCpm});
    }
    if (team.creativeTagTechFeeCpm) {
      rows.push({label: this.ogTranslate.transform('creativeTagTechFee'), fee: team.creativeTagTechFeeCpm});
    }
    _.forEach(team.supplementaryFees, (sFee: any) => {
      rows.push({label: sFee.name + ' (Supp.) Fee', fee: sFee});
    });
    _.forEach(team.targetingTypeTechFees, (fee: any, key: string) => {
      rows.push({label: this.getTargetTranslation(key) + ' Fee', fee});
    });
    _.forEach(team.layoutFees, (lFee: any) => {
      rows.push({label: _.get(lFee, ['layout', 'name']) + ' Fee', fee: lFee.fee});
    });
    return rows;
  }

  visibleTeamFeeRows(team: any, feeRows?: TeamFeeRow[]): TeamFeeRow[] {
    const rows = feeRows || this.getTeamFeeRows(team);
    if (team.showAllFees || rows.length <= 3) {
      return rows;
    }
    return rows.slice(0, 3);
  }
}
